export const PACStandardNumberUtil = (function () {

    return {

        getStandardNumbersByType: function(standardNumbers, type) {

            if(standardNumbers === null) {
                return [];
            }

            var inputValues = standardNumbers
                .filter(function (standardNumber) {
                    return standardNumber.type.toUpperCase() === type.toUpperCase();
                })
                .map(function (standardNumber) {
                    return standardNumber.data;
                });

            return inputValues;
        }
    }
})();